import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "item"]
  static classes = ["active", "hidden"]

  select(event) {
    const targetId = event.currentTarget.dataset.targetIdentifier

    // Update buttons
    this.buttonTargets.forEach(button => button.classList.remove(...this.activeClasses))
    event.currentTarget.classList.add(...this.activeClasses)

    // Update items
    this.itemTargets.forEach(item => item.classList.add(...this.hiddenClasses))
    document.getElementById(targetId).classList.remove(...this.hiddenClasses)
  }
} 